import {detailsTemplate} from "../../pages/survey/company/lists/details_template";
import Swal from "sweetalert2";
import {getCsrfToken} from "../get-csrf-token";
import {swalErrorFire, swalFire} from "../sweet-alert/sweet-alert-default";

export function prepareHeader(api, selectCol) {
    $('.filterHead', api.table().header()).each( function () {
        let title = $(this).text();
        $(this).html( '<input type="text" placeholder="Search '+title+'" class="column_search" />' );
    });
    api.table()
        .columns(selectCol)
        .every(function () {
            let column = this;
            let select = $('<select class="form-control outline-none"><option value=""></option></select>')
                .appendTo($('.selectHead').empty())
                .on('change', function () {
                    var val = $.fn.dataTable.util.escapeRegex($(this).val());
                    column.search(val ? `${val} [ajax_search_category]` : '', true, false).draw();
                });

            column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                    select.append('<option value="' + d + '">' + d + '</option>');
                });
        });
    api.table().columns().every(function (ctx) {
        let that = this;
        $('input', this.footer()).unbind().on('change keyup copy paste cut', function (ev) {
            if (that.search() !== this.value) {
                that.search(this.value + ` [${ev.target.className}]`).draw();
            }
        });
    })
}

export function handleRowClick(row, dt, data) {
    let detailRows = [];
    $(row).on('click', function (ev) {
        let tr = $(this).closest('tr');
        let row = dt.row(tr);
        let idx = detailRows.indexOf(tr.attr('id'));


        if (row.child.isShown()) {
            tr.removeClass('details');
            row.child.hide();

            // Remove from the 'open' array
            detailRows.splice(idx, 1);
        } else {
            if ($(ev.target).hasClass('disabled_details')) {
                return;
            }
            $.ajax({url: `/panel/survey/list/partials/details/${data[0]}`, success: function(result){
                    tr.addClass('details');
                    row.child(format(JSON.parse(result), data[0])).show();
                    // Add to the 'open' array
                    if (idx === -1) {
                        detailRows.push(tr.attr('id'));
                    }
                }});
        }
    });
}

function format(data, id) {
    return detailsTemplate(data, id);
}

export function handleSweetAlertModal(event, method) {
    var method               = method;
    const target             = $($(event.target).parent()[0]);
    const url                = target.attr('href');
    const title              = target.attr('data-original-title');
    const alertTitle         = target.attr('data-alert-title');
    const alertText          = target.attr('data-alert-text');
    const alertButton        = target.attr('data-alert-button');
    const confirmButtonText  = target.attr('data-alert-confirm-button-text');
    const confirmButtonClass = target.attr('data-alert-confirm-button-class');
    const cancelButtonText   = target.attr('data-alert-cancel-button-text');
    const cancelButtonClass  = target.attr('data-alert-cancel-button-class');
    Swal.fire({
        title: title,
        text: alertText,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        confirmButtonClass: confirmButtonClass,
        cancelButtonText: cancelButtonText,
        cancelButtonClass: cancelButtonClass,
        alertTitle: alertTitle,
        alertButton: alertButton,
        showLoaderOnConfirm: true,
        preConfirm: function() {
            return new Promise(function(resolve) {
                $.ajax({
                    type: method,
                    headers: {
                        'X-CSRF-TOKEN': getCsrfToken(),
                        'accept': 'application/json'
                    },
                    url: url,
                    success: function (data) {
                        if(data.redirectUrl) {
                            window.location.href = data.redirectUrl;

                            return;
                        }
                        const delayTime = 2000; // milliseconds
                        swalFire({
                            title: 'The survey is marked as completed',
                            text: 'You will be redirected in a moment.',
                            icon: 'success',
                            timer: delayTime
                        });
                    },
                    error: function (data) {
                        swalErrorFire({
                            title: 'Error',
                            text: 'Something went wrong.',
                        });
                    },
                });
            });
        }
    });
}
